'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 'ivj3t6-0'
})(['content:\'\';display:inline-block;width:', ';height:', ';margin-right:calc(', ' / 2);background-color:', ';border:1px solid ', ';border-radius:50%;'], function (p) {
  return p.theme.spacingUnitRadio;
}, function (p) {
  return p.theme.spacingUnitRadio;
}, function (p) {
  return p.theme.spacingUnitRadio;
}, function (p) {
  return p.theme.inputBgColor;
}, function (p) {
  return p.theme.borderColor;
});